import { Bundle } from '@/ui/services/BundleService';
import { isCountryRestrictedWithMessage } from '@/utils/tile-country-visibility';
import { ParsedProductVariant } from '../types/ParsedProductVariant';
import { SelectedProductVariants } from '../types/SelectedProductVariants';
import { ParsedSmartlockVariant } from '../SmartlockDetail/types/ParsedSmartlockVariant';
import { ParsedAccessoryVariant } from '../AccessoryDetail/types/ParsedAccessoryVariant';

export interface ChooserSelection {
  currentVariant: ParsedProductVariant | ParsedSmartlockVariant | ParsedAccessoryVariant;
  selectedBundle?: Bundle;
  selectedBundleProductVariants?: SelectedProductVariants;
  country?: string | null;
}

/**
 * A country-restricted selection in "show_message" mode must surface the existing "not
 * available" notice, so the chooser treats it as unavailable regardless of stock. Cylinder and
 * wildcard tiles only exist on hardware/accessory variants. A selected set is restricted as
 * well when one of its other slots holds a cylinder the country withholds.
 */
export function isChooserSelectionRestricted({
  currentVariant,
  selectedBundle,
  selectedBundleProductVariants,
  country,
}: ChooserSelection): boolean {
  const restrictedSelections = [
    'cylinder' in currentVariant ? currentVariant.cylinder : undefined,
    'wildcard' in currentVariant ? currentVariant.wildcard : undefined,
  ];
  const isHostRestricted = restrictedSelections.some(
    (tile) => !!tile && isCountryRestrictedWithMessage(tile, country),
  );

  return (
    isHostRestricted ||
    !!selectedBundle?.isSelectionRestrictedInCountry(selectedBundleProductVariants, country)
  );
}
